// focusUtils.js

export const disableFocusInHiddenSlides = () => {
    const hiddenSlides = document.querySelectorAll('[aria-hidden="true"]');
  
    hiddenSlides.forEach(slide => {
      const focusableElements = slide.querySelectorAll('a, button, input, textarea, select, [tabindex]');
      focusableElements.forEach(element => {
        element.setAttribute('tabindex', '-1');
      });
    });
  };
  
  export const enableFocusInVisibleSlides = () => {
    const visibleSlides = document.querySelectorAll('[aria-hidden="false"]');
  
    visibleSlides.forEach(slide => {
      const focusableElements = slide.querySelectorAll('a, button, input, textarea, select, [tabindex="-1"]');
      focusableElements.forEach(element => {
        element.removeAttribute('tabindex');
      });
    });
  };
  
  // Attach the functions to the window object
  window.disableFocusInHiddenSlides = disableFocusInHiddenSlides;
  window.enableFocusInVisibleSlides = enableFocusInVisibleSlides;
  